<template>
  <!-- 公用组件  -->
  <div class="MaInuptTwo ub ub-ac">
    <span class="label_name">{{labelName}}:</span>
    <span class="ub-f1">
      <el-date-picker
      ref="input"
        v-model="value1"
        :disabled="isdisable"
        type="date"
        placeholder="选择日期"
        size="mini"
        class="date_sty"
        value-format="yyyy-MM-dd"
        @change="selectChange"
        @keydown.enter.native="enterDown"
      ></el-date-picker>
    </span>
  </div>
</template>

<script>
export default {
  name: "MaInuptTwo",
  data() {
    return {
      value1: this.value
    };
  },
  methods: {
      selectChange(){
        // console.log(7788)
          // this.$emit('nextFocus');
      },
      enterDown(){
        let that =  this;
        setTimeout(() => {
          that.$emit('nextFocus');
        }, 100);
      }
  },
  watch: {
    value1() {
      this.$emit("dateChange", this.value1, this.fieldData);
    },
    value(newVal){
      this.value1 = newVal;
    }
  },
  props: {
    value: [String, Object, Date],
    labelName: {
      type: String,
      default: "单据日期"
    },
    isdisable: {
      type: Boolean,
      default: true
    },
    isMust: {
      type: Boolean,
      default: true
    },
    // 传入的外部字段，将用于传出识别
    fieldData: { type: String }
  }
};
</script>

<style lang="less">
.MaInuptTwo {
  height: 28px;
  color: #000;
  border: 1px solid #d6e2ed;
  border-radius: 5px;
  padding: 0 5px;
  box-sizing: border-box;
  overflow: hidden;
  .label_name {
    height: 100%;
    line-height: 28px;
    font-size: 12px;
    color: inherit;
    font-weight: bold;
  }
  span,
  .label_name {
    display: block;
  }
  .input_sty {
    position: relative;
    -webkit-box-flex: 1;
    box-flex: 1;
    display: block;
    height: 100%;
  }
  .el-input__inner,
  .el-input__inner:hover {
    border-color: #fff;
  }
  .date_sty {
    width: 100%;
  }
}

</style>
<style lang="less" scoped>
// 重写不可输入的input背景颜色、边框等
.el-input.is-disabled .el-input__inner {
    background-color: #fff;
    border-color: #fff;
}
</style>


// WEBPACK FOOTER //
// src/components/Input/MaInuptTwo/MaInuptTwo.vue